import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sizes-guide',
  standalone: false,
  templateUrl: './sizes-guide.component.html',
  styleUrl: './sizes-guide.component.scss',
})
export class SizesGuideComponent implements OnInit {
  sizeGuide: any = null;
  selectedGuide: any = null;
  selectedTabIndex: number = 0;
  isLoading: boolean = true; // Add loading state
  error: any = null; // Add error handling

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<any>('data/size-guide.json').subscribe({
      next: (data: any) => {
        this.sizeGuide = data;
        this.selectTab(this.selectedTabIndex);
        this.isLoading = false;
      },
      error: (err) => {
        this.error = err;
        this.isLoading = false;
      },
    });
  }

  selectTab(index: number) {
    if (this.sizeGuide) {
      // Add null check
      this.selectedTabIndex = index;
      this.selectedGuide = this.sizeGuide[index];
    }
  }
}
